import { render, staticRenderFns } from "./SelectCouponStatus.vue?vue&type=template&id=1ed975f4&scoped=true"
import script from "./SelectCouponStatus.vue?vue&type=script&lang=js"
export * from "./SelectCouponStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed975f4",
  null
  
)

export default component.exports